import { aboutContent } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-8">
          {aboutContent.title}
        </h2>
        <div className="max-w-3xl">
          {aboutContent.paragraphs.map((p, idx) => (
            <p key={idx} className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4 last:mb-0">
              {p}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
}